import { Component, type ReactNode } from "react";

interface ErrorBoundaryProps {
  children: ReactNode;
  fallback?: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  errorDetails: string | null;
  errorMessage: string;
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  public state: ErrorBoundaryState = {
    hasError: false,
    errorMessage: "Unbekannter Fehler aufgetreten.",
    errorDetails: null,
  };

  public static getDerivedStateFromError(error: unknown): ErrorBoundaryState {
    const details = error instanceof Error ? error.message : "Unbekannter Fehler aufgetreten.";

    return {
      hasError: true,
      errorMessage: "Ein unerwarteter Fehler ist aufgetreten.",
      errorDetails: import.meta.env.DEV ? details : null,
    };
  }

  public render(): ReactNode {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }

    return (
      <div className="min-h-screen bg-slate-50 px-4 py-20 text-slate-900 dark:bg-slate-950 dark:text-slate-100">
        <div className="mx-auto flex max-w-3xl flex-col items-start gap-3 rounded border border-rose-300 bg-rose-50 p-6 dark:border-rose-900/40 dark:bg-rose-950/20">
          <h1 className="text-lg font-semibold">Unbehandelter Fehler</h1>
          <p className="text-sm text-slate-700 dark:text-slate-300">{this.state.errorMessage}</p>
          {import.meta.env.DEV && this.state.errorDetails ? (
            <p className="text-xs text-slate-600 dark:text-slate-400">{this.state.errorDetails}</p>
          ) : null}
            <button
              type="button"
              className="rounded bg-rose-600 px-4 py-2 text-sm text-white disabled:opacity-50 dark:bg-rose-500 dark:hover:bg-rose-400"
              onClick={() => window.location.reload()}
            >
              Neu laden
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
